/**
 * Scroll ONE container so `target` sits at its top.
 *
 * `Element.scrollIntoView` walks every scrollable ancestor, so called inside the Inspector it
 * can also shift the editor page and the canvas on a short viewport. The Inspector is its own
 * scroll box, and everything this page wants to reveal lives inside it, so the scroll is
 * applied to that box alone and nothing outside it moves.
 */
export function scrollWithin(container: HTMLElement, target: HTMLElement): void {
  const offset = target.getBoundingClientRect().top - container.getBoundingClientRect().top
  container.scrollTop += offset
}
